<template>
  <Nav v-show="isNavBarVisible" id="navbar-main" class="navbar is-fixed-top">
    <div v-if="true" class="has-padding-top-15 has-padding-left-15">
      <router-link :to="{ name: 'Home' }">
        <img
          src="https://res.cloudinary.com/nailedd/image/upload/v1584032179/capturefit/logo-black-bg.png"
          style="width: 200px"
        />
      </router-link>
    </div>
    <div v-if="isAuthenticated" class="navbar-brand">
      <!-- <a
        class="navbar-item is-hidden-desktop"
        @click.prevent="menuToggleMobile"
      >
        <b-icon :icon="menuToggleMobileIcon" />
      </a> -->
    </div>
    <div v-if="isAuthenticated" class="navbar-brand is-right">
      <a
        class="navbar-item navbar-item-menu-toggle is-hidden-desktop"
        @click.prevent="menuNavBarToggle"
      >
        <b-icon :icon="menuNavBarToggleIcon" custom-size="default" />
      </a>
    </div>
    <div
      class="navbar-menu fadeIn animated faster"
      :class="{ 'is-active': isMenuNavBarActive }"
    >
      <div class="navbar-end">
        <router-link class="navbar-item" :to="{ name: 'Home' }">
          <span>All Events</span>
        </router-link>
        <router-link
          v-if="user.superadmin"
          class="navbar-item"
          :to="{ name: 'ManageAdmins' }"
        >
          <span>Manage Admins</span>
        </router-link>
        <NavBarMenu v-if="$route.meta && $route.meta.quicklinks">
          <div>
            <span>Manage</span>
          </div>

          <div slot="dropdown" class="navbar-dropdown">
            <router-link
              class="navbar-item"
              :to="{
                name: 'EventDashboard',
                params: { eventid: event._id },
              }"
              ><span>Dashboard</span></router-link
            >
            <router-link
              class="navbar-item"
              :to="{
                name: 'EditEventBasicInfo',
                params: { eventid: event._id },
              }"
            >
              <span>Edit Event Details</span>
            </router-link>
            <router-link
              class="navbar-item"
              :to="{
                name: 'EditEventOptions',
                params: { eventid: event._id },
              }"
            >
              <span>Edit Event Options</span>
            </router-link>
            <router-link
              class="navbar-item"
              :to="{
                name: 'ManageRegistrations',
                params: { eventid: event._id },
              }"
            >
              <span>Entries</span>
            </router-link>
            <router-link
              v-if="event && event.config && event.config.waitinglist"
              class="navbar-item"
              :to="{
                name: 'ManageWaitingList',
                params: { eventid: event._id },
              }"
            >
              <span>Waiting List</span>
            </router-link>
            <router-link
              class="navbar-item"
              :to="{
                name: 'ManageDivisions',
                params: { eventid: event._id },
              }"
              >Divisions</router-link
            >
            <router-link
              class="navbar-item"
              :to="{
                name: 'ManageLeaderboard',
                params: { eventid: event._id },
              }"
            >
              <span>Leaderboard</span>
            </router-link>
            <router-link
              class="navbar-item"
              :to="{
                name: 'ManageSpectators',
                params: { eventid: event._id },
              }"
            >
              <span>Spectators</span>
            </router-link>
            <router-link
              class="navbar-item"
              :to="{
                name: 'ManageJudges',
                params: { eventid: event._id },
              }"
            >
              <span>Judges</span>
            </router-link>
            <router-link
              class="navbar-item"
              :to="{
                name: 'ManageVolunteers',
                params: { eventid: event._id },
              }"
            >
              <span>Volunteers</span>
            </router-link>
            <router-link
              class="navbar-item"
              :to="{
                name: 'ManageVendors',
                params: { eventid: event._id },
              }"
            >
              <span>Vendors</span>
            </router-link>
            <router-link
              class="navbar-item"
              :to="{
                name: 'ManageVoucherCodes',
                params: { eventid: event._id },
              }"
              ><span>Invite Links/Voucher Codes</span></router-link
            >

            <a
              href=""
              class="navbar-item"
              @click.prevent="populateLeaderboard()"
              ><span>Populate Leaderboard</span></a
            >
          </div>
        </NavBarMenu>
        <a
          href="https://help.capturefit.com"
          target="_blank"
          class="navbar-item"
        >
          <span>Contact</span>
        </a>
        <a href="/" class="navbar-item">
          <span>View Website</span>
        </a>
        <a href="/cf-admin" class="navbar-item">
          <span>Admin Area v1</span>
        </a>
        <a
          v-if="isAuthenticated"
          class="navbar-item is-desktop-icon-only"
          title="Log out"
          @click.prevent="doLogout"
        >
          <b-icon icon="logout" custom-size="default" />
          <span>Log out</span>
        </a>
      </div>
    </div>
  </Nav>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import NavBarMenu from '@/components/NavBarMenu'
import LeaderboardApi from '@/api/leaderboard'

export default {
  name: 'NavBar',
  components: {
    NavBarMenu,
  },
  data() {
    return {
      isMenuNavBarActive: false,
    }
  },
  computed: {
    menuNavBarToggleIcon() {
      return this.isMenuNavBarActive ? 'close' : 'dots-vertical'
    },
    menuToggleMobileIcon() {
      return this.isAsideMobileExpanded ? 'backburger' : 'forwardburger'
    },
    ...mapState(['isNavBarVisible', 'isAsideMobileExpanded', 'userName']),
    ...mapGetters(['isAuthenticated', 'user', 'event']),
  },
  methods: {
    ...mapActions(['logout']),
    menuToggleMobile() {
      this.$store.commit('asideMobileStateToggle')
    },
    menuNavBarToggle() {
      this.isMenuNavBarActive = !this.isMenuNavBarActive
    },
    async doLogout() {
      this.logout()
      this.$router.push({ name: 'Login' })
    },
    async populateLeaderboard() {
      await LeaderboardApi.populateLeaderboard(this.event._id)
      this.$buefy.toast.open({
        message: `Leaderboard populated successfully!`,
        position: 'is-top',
        type: 'is-success',
      })
    },
  },
}
</script>

<style>
#navbar-main {
  background: #222;
}

.navbar-end > .navbar-item,
.navbar-end .navbar-link {
  color: #fff !important;
}

.navbar-end > .navbar-item:hover,
.navbar-item.has-dropdown:hover .navbar-link,
.navbar-item.has-dropdown:focus .navbar-link,
a.navbar-item:focus,
a.navbar-item:focus-within,
a.navbar-item:hover,
a.navbar-item.is-active,
.navbar-link:focus,
.navbar-link:focus-within,
.navbar-link:hover,
.navbar-link.is-active,
nav.navbar .navbar-item.has-dropdown.is-active .navbar-link {
  background-color: #000;
}
</style>
